import PriceRangeFilter from '@/src/components/common/srp/filters/priceRangeFilter/priceRangeFilter'
import { useSrpContext } from '@/src/contexts'
import { Box, Divider } from '@mui/material'
import { useTranslations } from 'next-intl'

const SEOPriceFilter = () => {
    const t = useTranslations('common')

    const {
        SEOSrpData: { filterData }
    } = useSrpContext()
    const { oneWayPrice } = filterData || {}
    const { min, max } = oneWayPrice || {}
    const title = t('price')
    return (
        <Box sx={{ width: '100%' }}>
            <Divider />
            <PriceRangeFilter
                minPrice={min || 0}
                maxPrice={max || 0}
                title={title}
                key={`${min}-${max}`}
                currentMax={max || 0}
                currentMin={min || 0}
            />
            <Divider />
        </Box>
    )
}

export default SEOPriceFilter
